import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const ButtonStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  transition: ${VARIABLES.TRANSITIONS.DEFAULT};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  cursor: pointer;
  color: white;
  background-color: ${VARIABLES.COLORS.BLUE_2};

  &:hover {
    background-color: #5b54e8;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.35);
  }
  font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
  white-space: nowrap;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  &.link {
    border: 0;
    text-decoration: underline;
    color: ${VARIABLES.COLORS.BLUE_2};
    background-color: transparent;
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_NORMAL};
    display: inline-flex;
    width: auto;
    height: auto;
    /* -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0; */
    border-radius: 0;
    /* flex: 0 0 16px; */

    &:hover {
      background-color: transparent;

      &.cursor {
        cursor: default;
        background-color: transparent;
      }
    }
  }

  &.icon {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    width: 30px;
    height: 30px;
    background-color: transparent;
    border-radius: ${VARIABLES.BORDER_RADIUSES.MN};

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_1};
    }

    .image-control {
      width: 14px;
    }

    .delete-icon {
      width: 14px;
    }

    &-update {
      width: 26px;
      height: 26px;
      border: 1px solid #4b4acb;
      border-radius: 30px;
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
  }

  &.breadcrumb {
    border: 0;
    color: ${VARIABLES.COLORS.BLUE_2};
    background-color: transparent;
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_NORMAL};
    display: inline-block;
    width: auto;
    height: auto;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0;
    border-radius: 0;
    font-size: 14px;
    color: #94a3b8;
    cursor: pointer;
    margin-left: 5px;

    &.current {
      color: ${VARIABLES.COLORS.GRAY_3};
      cursor: initial;

      &:hover {
        span {
          text-decoration: none;
        }
      }
    }

    &:before {
      content: '/';
      display: inline;
      margin: 0 5px 0 0;
      text-decoration: none;
    }

    &:first-child {
      &:before {
        display: none;
      }
    }

    &:hover {
      background-color: transparent;

      span {
        text-decoration: underline;
        a {
          color: ${VARIABLES.COLORS.BLUE_9};
          text-decoration: none;
        }
      }
    }
    span {
      a {
        color: ${VARIABLES.COLORS.BLUE_9};
        text-decoration: none;
      }
    }
  }

  &.front-button {
    position: relative;
    z-index: 99;
  }
  &.theme-blue {
    background-color: ${VARIABLES.COLORS.BLUE_2};
    color: white;

    &:hover {
      background-color: #5b54e8;
    }
  }
  &.theme-green {
    background-color: ${VARIABLES.COLORS.GREEN_1};
    color: white;

    &:hover {
      background-color: ${VARIABLES.COLORS.GREEN_2};
    }
  }

  &.theme-gray {
    background-color: ${VARIABLES.COLORS.GRAY_9};
    color: white;

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_5};
    }
  }

  &.theme-border {
    background-color: white;
    border: 1px solid ${VARIABLES.COLORS.BLUE_8};
    color: ${VARIABLES.COLORS.BLUE_8};
    width: auto;
    padding: 0 60px;

    &:hover {
      background-color: white;
    }
  }

  &.theme-border-gray {
    background-color: white;
    border: 1px solid ${VARIABLES.COLORS.GRAY_9};
    color: ${VARIABLES.COLORS.GRAY_9};

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_9};
      color: white;
    }
  }

  &.theme-red {
    background-color: ${VARIABLES.COLORS.RED_1};
    color: white;
    &:hover {
      background-color: ${VARIABLES.COLORS.RED_4};
    }
  }

  &.logout {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin-left: 4px;
    border-radius: 10px;
    text-decoration: none;

    &:hover {
      background-color: #eef1ff;
      text-decoration: none;
    }
  }

  &.notification {
    &:hover {
    }
  }

  &.page-button {
    width: auto;
    padding: 13px 19px;
    align-items: center;
    margin-right: 10px;

    .image-control {
      width: 16px;
      margin-right: 11px;
      margin-bottom: 2px;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.add-new {
    width: auto;
    padding: 13px 19px;
    align-items: center;
    margin-right: 10px;

    .image-control {
      width: 16px;
      margin-right: 11px;
      margin-bottom: 2px;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.btn-back {
    padding: 0 35px;
    font-size: 16px;
    flex: 1;
    max-width: 230px;
    font-weight: 500;
  }

  &.theme-dodger-blue {
    background-color: ${VARIABLES.COLORS.BLUE_11};
    color: ${VARIABLES.COLORS.WHITE};

    &:hover {
      background-color: ${VARIABLES.COLORS.BLUE_11};
      color: ${VARIABLES.COLORS.WHITE};
    }
  }

  &.theme-light-blue {
    background-color: ${VARIABLES.COLORS.BLUE_12};
    color: ${VARIABLES.COLORS.WHITE};

    &:hover {
      background-color: ${VARIABLES.COLORS.BLUE_12};
      color: ${VARIABLES.COLORS.WHITE};
    }
  }

  &.theme-dashed-blue {
    background-color: ${VARIABLES.COLORS.GRAY_12};
    color: ${VARIABLES.COLORS.BLUE_1};
    border: 1px dashed ${VARIABLES.COLORS.BLUE_1};

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_12};
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  &.theme-border-red {
    background-color: transparent;
    border: 1px solid ${VARIABLES.COLORS.RED_6};
    color: ${VARIABLES.COLORS.RED_6};

    &:hover {
      background-color: transparent;
      color: ${VARIABLES.COLORS.RED_6};
    }
  }

  &.btn-height-32 {
    height: 32px;
    width: auto;
    font-size: 14px;
    padding: 0 1rem;
  }

  &.theme-solid-blue {
    background-color: transparent;
    border: 1px solid ${VARIABLES.COLORS.BLUE_1};
    color: ${VARIABLES.COLORS.BLUE_1};

    &:hover {
      background-color: transparent;
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  /* State
  ------------------------------- */
  &.is-disabled {
    background-color: ${VARIABLES.COLORS.GRAY_9};
    color: white !important;
    cursor: not-allowed !important;
    pointer-events: none;

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_9} !important;
    }

    &.is-transparent {
      background-color: transparent !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
      &:hover {
        background-color: transparent !important;
      }
    }
    &.btn-link {
      .image-control {
        filter: grayscale(200%);
        opacity: 0.3;
      }
    }
  }

  &:hover {
    background-color: ${VARIABLES.COLORS.BLUE_3};
  }

  &.btn-width-auto {
    padding: 0 1rem;
    width: auto !important;
  }

  &.btn-icon {
    width: auto !important;

    .image-control {
      margin-right: 0.5rem;
    }
  }

  &.btn-link {
    width: auto !important;
    background-color: transparent;
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    font-size: 16px;
    height: 40px;

    &.page-button {
      .image-control {
        width: 15px;
        margin-right: 10px;
        margin-bottom: 2px;
      }
    }

    &.add-new {
      .image-control {
        width: 15px;
        margin-right: 10px;
        margin-bottom: 2px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    font-size: 15px;
    height: 38px;

    &.page-button {
      .image-control {
        width: 14px;
        margin-right: 9px;
        margin-bottom: 2px;
      }
    }

    &.add-new {
      .image-control {
        width: 14px;
        margin-right: 9px;
        margin-bottom: 2px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    font-size: 14px;
    height: 36px;

    &.logout {
      flex: 0 0 25px;
      width: 25px;
      height: 25px;

      .image-control {
        width: 13px;
      }
    }

    &.page-button {
      .image-control {
        width: 13px;
        margin-right: 8px;
        margin-bottom: 1px;
      }
    }

    &.add-new {
      .image-control {
        width: 13px;
        margin-right: 8px;
        margin-bottom: 1px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    font-size: 13px;
    height: 34px;

    &.icon {
      margin-top: 0;

      .image-control {
        width: 12px;
        height: 12px;
        flex: 0 0 12px;
      }
    }

    &.page-button {
      .image-control {
        width: 12px;
        margin-right: 7px;
      }
    }

    &.add-new {
      .image-control {
        width: 12px;
        margin-right: 7px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    font-size: 12px;
    height: 32px;

    &.icon {
      .image-control {
        width: 10px;
        height: 10px;
        flex: 0 0 10px;
      }
    }

    &.logout {
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      padding: 0 0 1px 1px;

      .image-control {
        width: 11px;
      }
    }

    &.page-button {
      .image-control {
        width: 11px;
        margin-right: 5px;
        margin-bottom: 0;
      }
    }

    &.add-new {
      .image-control {
        width: 11px;
        margin-right: 5px;
        margin-bottom: 0;
      }
    }
  }
`
